import * as React from 'react';
import InvitationListItem from './InvitationListItem';
import Section from './Section';
import { Invitation } from '../invitation';

type Props = {
  invitations: Invitation[];
};

export default function InvitationList(props: Props) {
  return (
    <React.Fragment>
      <Section title="Active">
        {props.invitations.map((invitation: Invitation, index: number) => (
          <InvitationListItem
            invitation={invitation}
            index={index}
            key={index}
          />
        ))}
      </Section>
    </React.Fragment>
  );
}
